import { AuditFilter, AuditLog, ListResult } from 'common/api/v1/types'
import { EdgeClient } from 'common/generated/edgeClient'
import { AuditLogRequestParams, singleSortQueryFromPaginatedRequestParams } from '../nm-types'

export class AuditApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  getAudit({
    entity,
    entityName,
    fromDate,
    operation,
    toDate,
    username,
    result,
    ...params
  }: AuditLogRequestParams): Promise<ListResult<AuditLog>> {
    const filter: AuditFilter = {
      entity,
      entityName,
      fromDate: fromDate as unknown as Date,
      operation,
      result,
      toDate: toDate as unknown as Date,
      username,
    }
    const query = singleSortQueryFromPaginatedRequestParams({ filter, paginatedRequestParams: params })
    return this.edgeClient.listAuditLogs(query)
  }
}
